/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '@/store/store'

Vue.use(Router)

export const createAuthGuard = storeInstance => (to, from, next) => {
  const isAuthenticated = Boolean(storeInstance.state.users.currentUser.token)
  const userRoles = storeInstance.getters['users/currentUserRoles'] || []
  const requiredRoles = to.matched.flatMap(record => (record.meta && record.meta.requiredRoles) || [])

  if (isAuthenticated && to.name === 'login') return next({ name: 'home' })

  if (requiredRoles.length) {
    if (!isAuthenticated) return next({ name: 'login' })

    if (to.name !== 'page-not-authorized') {
      const hasRequiredRole = requiredRoles.some(role => userRoles.includes(role))
      if (!hasRequiredRole) return next({ name: 'page-not-authorized' })
    }
  }

  return next()
}

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
      ...routes
    ],
})

router.beforeResolve(async (to, from, next) => {
  return createAuthGuard(store)(to, from, next)
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
